import type { RouterConfig } from '@nuxt/schema'

// https://router.vuejs.org/api/#routeroptions
export function getRouterConfig(): RouterConfig {
  return {
    scrollBehavior(to, from, savedPosition) {
      return new Promise((resolve, _reject) => {
        setTimeout(
          async () => {
            if (to.hash) {
              let element: HTMLElement | null = null

              // wait till element is rendered - e.g. for case of dynamic components
              for (let timeleft = 1500; timeleft > 0; timeleft -= 100) {
                const id = CSS.escape(to.hash.slice(1).split('?')[0])

                if (!id) {
                  break
                }

                element = document.getElementById(id)
                if (element) {
                  break
                }

                await new Promise((resolve) => {
                  setTimeout(() => {
                    resolve(true)
                  }, 100)
                })
              }

              resolve(
                element
                  ? {
                      el: element,
                      top: 100,
                      behavior: from.path === to.path ? 'smooth' : 'auto',
                    }
                  : { top: 0 },
              )
            }
            else if (to.path === from.path) {
              resolve()
            }
            else if (savedPosition) {
              resolve(savedPosition)
            }
            else {
              resolve({ top: 0 })
            }
          },
          to.meta.pageTransition ? 250 : 100,
        )
      })
    },
  }
}
